import { lazy, Suspense, useMemo } from 'react';
import { createSearchParams, Route } from 'react-router-dom';

import { QueryLoading } from 'modules/common/components/QueryLoading';
import { ROOT_PATH } from 'modules/common/const';
import { createRouteConfig } from 'modules/common/utils/createRouteConfig';
import { stakableTokens, TNativeToken } from 'modules/api';
import { useQueryParams } from 'modules/common/hooks/useQueryParams';

const PATH = ROOT_PATH;

interface IStakeParams {
  token?: TNativeToken;
}

export const dashboardRouteConfig = createRouteConfig(
  {
    main: {
      path: PATH,
      generatePath: (params?: IStakeParams) => {
        if (!params) {
          return PATH;
        }

        const { token = '' } = params;
        const searchParams = createSearchParams({
          token,
        });

        return `${PATH}?${searchParams.toString()}`;
      },
      useParams: (): IStakeParams => {
        const queryParams = useQueryParams();
        const tokenParam = queryParams.get('token')?.toUpperCase() ?? undefined;

        const token = useMemo(
          () => stakableTokens.find(el => el === tokenParam),
          [tokenParam],
        );

        return {
          token,
        };
      },
    },
  },
  PATH,
);

const Dashboard = lazy(() =>
  import('./screens/Dashboard').then(({ Dashboard }) => ({
    default: Dashboard,
  })),
);

export function getDashboardRoutes(): JSX.Element {
  return (
    <>
      <Route
        element={
          <Suspense fallback={<QueryLoading isAbsolute />}>
            <Dashboard />
          </Suspense>
        }
        path={dashboardRouteConfig.main.path}
      />
    </>
  );
}
